import { desenhaTroTms, processaResultados } from './Aux.js';

export const dotmsRank = (ling, map, coords, rows, l1, l2, l3, l4, nv, stationAtms, stationBtms, shortv) => {
    if (!map || !rows || rows.length === 0) {
        if (rows && rows.length === 0) tmsAlertaDados(ling);
        return;
    }
    let cor = '#008000';
    let tratados = processaResultados(rows, nv, stationAtms, stationBtms);
    console.log(rows, tratados);
    for (let i = 0; i < tratados.length; i++) {
        if (i === l1){
            cor = '#00FF00';
        }
        if (i === l2){
            cor = '#FFDF00';
        }
        if (i === l3){
            cor = '#FF8C00';
        }
        if (i === l4){
            cor = '#FF0000';
        }
        if (tratados[i][2] > 0) {
            desenhaTroTms(coords, tratados[i], cor, map);
        }
    }
    let desde = " De " + tratados[l1-1][2].toLocaleString('en-US') + " a ";
    let ate = tratados[0][2].toLocaleString('en-US') + " " + shortv;
    document.getElementById("verdescuro").innerHTML = desde + ate + " (ranking 1 a " + l1 + ")";
    desde = " De " + tratados[l2-1][2].toLocaleString('en-US') + " a ";
    ate = tratados[l1][2].toLocaleString('en-US') + " " + shortv;
    document.getElementById("verdeclaro").innerHTML = desde + ate + " (ranking " + l1 + " a " + l2 + ")";
    desde = " De " + tratados[l3-1][2].toLocaleString('en-US') + " a ";
    ate = tratados[l2][2].toLocaleString('en-US') + " " + shortv;
    document.getElementById("amarelo").innerHTML = desde + ate + " (ranking " + l2 + " a " + l3 + ")";
    desde = " De " + tratados[l4-1][2].toLocaleString('en-US') + " a ";
    ate = tratados[l3][2].toLocaleString('en-US') + " " + shortv;
    document.getElementById("laranja").innerHTML = desde + ate + " (ranking " + l3 + " a " + l4 + ")";
    desde = " De " + tratados[78][2].toLocaleString('en-US') + " a ";
    ate = tratados[l4][2].toLocaleString('en-US') + " " + shortv;
    document.getElementById("vermelho").innerHTML = desde + ate + " (ranking " + l4 + " a 83)";
}

export const dotmsInterv = (ling, map, coords, rows, l1, l2, l3, l4, nv, stationAtms, stationBtms, shortv) => {
    if (!map || !rows || rows.length < 1) {
        if (rows && rows.length === 0) tmsAlertaDados(ling);
        return;
    }
    let num;
    let tratados = processaResultados(rows, nv, stationAtms, stationBtms);
    console.log(tratados);
    for (let i = 0; i < tratados.length; i++) {
        num = tratados[i][2];
        if (num  === 0) break;
        let cor = '#008000';
        if (num<l1){
            cor = '#00FF00';
        }
        if (num<l2){
            cor = '#FFDF00';
        }
        if (num<l3){
            cor = '#FF8C00';
        }
        if (num<l4){
            cor = '#FF0000';
        }
        desenhaTroTms(coords, tratados[i], cor, map);
    }
    let desde = " De 9,999,999 a ";
    let ate = l1.toLocaleString('en-US') + " " + shortv;
    document.getElementById("verdescuro").innerHTML = desde + ate;
    desde = " De " + l1.toLocaleString('en-US') + " a ";
    ate = l2.toLocaleString('en-US') + " " + shortv;
    document.getElementById("verdeclaro").innerHTML = desde + ate;
    desde = " De " + l2.toLocaleString('en-US') + " a ";
    ate = l3.toLocaleString('en-US') + " " + shortv;
    document.getElementById("amarelo").innerHTML = desde + ate;
    desde = " De " + l3.toLocaleString('en-US') + " a ";
    ate = l4.toLocaleString('en-US') + " " + shortv;
    document.getElementById("laranja").innerHTML = desde + ate;
    desde = " De " + l4.toLocaleString('en-US') + " a ";
    ate = "0 " + shortv;
    document.getElementById("vermelho").innerHTML = desde + ate;
}

function tmsAlertaDados(ling) {
    if (ling === 'pt') {
        alert ('Não há dados para o período especificado! Só de Jan 2016 a Fev 2021, inc. para todos os dias e para Nov 2016 a Fev 2021, inc. para dias úteis.');
    } else {
        alert ('No data for the specified period! Only for Jan 2016 to Feb 2021, inc. (for all days) and for Nov 2016 to Feb 2021, inc. (for week days).')
    }
}